import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('work-grid-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            category: 'all',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if(window.location.hash) {
            let hash = window.location.hash.substring(1);
            this.setFilter(hash);
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setDropdownValue(categoryID, categoryTitle) {
            this.category = categoryTitle;
            let categoryId = categoryID;
            this.toggleDropdown();

            if (this.category == 'all') {
                document.querySelectorAll('.work-grid__item').forEach(function(el) {
                    el.style.display = 'block';
                });

                return;
            }

            document.querySelectorAll('.work-grid__item').forEach(function(el) {
                el.style.display = 'none';
            });
                        
            document.querySelectorAll('.' + categoryId).forEach(function(el) {
                el.style.display = 'block';
            });
        },

        toggleDropdown() {
            const dropdown = document.getElementById("dropdown");
            const dropdowninner = document.getElementById("dropdowninner");

            if (dropdown.classList.contains('dropdown__custom-selected--open')) {
                dropdown.classList.remove('dropdown__custom-selected--open');
                gsap.to(dropdowninner, {
                    duration: 0.4,
                    height: 0,
                    ease: 'Quad.easeOut'
                });
            } else {
                dropdown.classList.add('dropdown__custom-selected--open');
                gsap.to(dropdowninner, {
                    duration: 0.8,
                    height: 'auto',
                    ease: 'power2.out'
                });
            }
        },


        setFilter(hash) {
            let element = document.getElementById(hash);
            if (element) {
                element.click();
            }             
        },

    }
});
